import { ChangeDetectionStrategy, Component } from '@angular/core';

// Inline badge shown next to the BDF state when the job was generated with the
// high-resolution mesh option. Its own component so it looks the same in every
// dialog and list that shows it.
@Component({
  selector: 'app-bdf-highres-badge',
  template: `High res`,
  styleUrl: './bdf-highres-badge.component.scss',
  host: {
    role: 'note',
    'aria-label': 'Generated with high-resolution mesh',
    title: 'Generated with high-resolution mesh',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdfHighresBadgeComponent {}
